import React, { useEffect, useState } from "react";
import Select from "react-select";
import 'react-dropdown/style.css';

const defaultOption = {
        label: "Select one...",
        value: "default"
}

function UserInput({ onSendClick, onResetClick, inputOptions }) {
  const [dropdownOptions, setDropdownOptions] = useState([defaultOption]);
  const [inputSelectState, setInputSelectState] = useState(defaultOption)
  const [demoName, setDemoName] = useState("");

  useEffect(() => {
    setDropdownOptions(
      [defaultOption,
      ...inputOptions.map(item => ({
        label: item,
        value: item
      }))
    ])
  }, [inputOptions]);

  const handleSendClick = () => {
    onSendClick(demoName);
  };

  const handleResetClick = () => {
    setInputSelectState(defaultOption);
    onResetClick();
  };

  const handleSelect = (option) => {
    setInputSelectState(option);
    setDemoName(option.value);
  }

  return (
    <div className="user-input">
      <h2 className="otherhead">Input</h2>
      <div>
        <Select 
        className="dropdown"
        options={dropdownOptions} 
        onChange={handleSelect}
        value={inputSelectState}
        />
      </div>
      <button onClick={handleSendClick}>Send</button>
      <button onClick={handleResetClick}>Reset</button>
    </div>
  );
}

export default UserInput;
